import React, { Component } from 'react'
import { connect } from 'react-redux'
import NippoCell from '../components/NippoCell'
import NippoSideMenu from '../components/NippoSideMenu'
import NippoModal from '../components/NippoModal'
import { setHeader, loadNextNippoList } from '../actions'

class Nippo extends Component {
  componentWillMount() {
    const { setHeader } = this.props
    setHeader({
      title: "にっぽー！",
      left: null,
      right: null
    })
  }

  render() {
    const { nippoList, nippoFiltered, daysBefore, selectedNippo, selectedTeams, loadNextNippoList } = this.props

    return (
        <div className="nippo content">
          <div className="columns">
            <div className="column is-two-thirds">
              { nippoList && selectedTeams.length === 0 ?
                Object.keys(nippoList).map(nippoId =>
                  <NippoCell name="nippo" key={nippoId} id={nippoId} nippoData={nippoList[nippoId]} />
                )
              : nippoFiltered && selectedTeams.length !== 0 ?
                Object.keys(nippoFiltered).map(nippoId =>
                  <NippoCell name="nippo" key={nippoId} id={nippoId} nippoData={nippoFiltered[nippoId]} />
                )
              :
                <div>Loading...</div>
              }
              <a className="button is-fullwidth" onClick={e => loadNextNippoList(daysBefore)}>More</a>
            </div>
            <NippoSideMenu />
          </div>
          { selectedNippo === null ? null : <NippoModal /> }
        </div>
    )
  }
}

export default connect(
  state => ({
    nippoList: state.nippo.nippoList,
    nippoFiltered: state.nippo.nippoFiltered,
    daysBefore: state.nippo.daysBefore,
    selectedNippo: state.nippo.selectedNippo,
    selectedTeams: state.nippo.selectedTeams
  }),
  { setHeader, loadNextNippoList }
)(Nippo)



// WEBPACK FOOTER //
// ./src/containers/Nippo.js